export default {
    baseStyle: () => ({
        emptyPageContent: {
            padding: '0 64px'
        },
        emptyPageHeading: {
            mb: 5,
            lineHeight: '1.2',
            overflowWrap: 'break-word',
            wordWrap: 'breakWord',
            fontWeight: 'extrabold',
            fontSize: '35px',
            textTransform: 'uppercase'
        },
        emptyPageSubHeading: {
            fontSize: '22px',
            mb: '15px',
            fontWeight: 'extrabold',
            lineHeight: '1.2'
        },
        emptyResultsSuggestionsBlock: {
            marginBottom: '20px'
        }
    }),
    parts: [
        'emptyPageContainer',
        'emptyPageContent',
        'emptyPageHeading',
        'emptyResultsSuggestionsBlock'
    ]
}
